export var AlertTypes = {
    warning: 'warning',
    info: 'info',
    success: 'success',
    danger: 'danger',
};
